/**
 * Payment Service Type Constants
 *
 * Maps backend service types to frontend payment method types.
 * Single source of truth for service type strings.
 */

/** Backend service type strings (as returned by API) */
export const PAYMENT_SERVICE_TYPES = {
  TILL_PAYMENTS: 'till_payments',
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
  ZEN_GIFT_CARDS: 'zen_gift_cards',
} as const;

export type PaymentServiceTypeValue =
  (typeof PAYMENT_SERVICE_TYPES)[keyof typeof PAYMENT_SERVICE_TYPES];

/** Maps backend service types to frontend PaymentMethodType */
export const SERVICE_TYPE_TO_METHOD = {
  [PAYMENT_SERVICE_TYPES.TILL_PAYMENTS]: 'card',
  [PAYMENT_SERVICE_TYPES.APPLE_PAY]: 'applePay',
  [PAYMENT_SERVICE_TYPES.GOOGLE_PAY]: 'googlePay',
} as const;

/** Supported service types for deriving available methods */
export const SUPPORTED_SERVICE_TYPES = [
  PAYMENT_SERVICE_TYPES.TILL_PAYMENTS,
  PAYMENT_SERVICE_TYPES.APPLE_PAY,
  PAYMENT_SERVICE_TYPES.GOOGLE_PAY,
] as const;
